import React from 'react';
import env from '../../environment';
import './card-title-parcela.css';

const CardTitleParcela = ({ cuenta_uuid = null, cuenta_name, parcela_name, localidad, municipio, certifications }) => {
  return (
    <>
      <div className="col-xs-3 col-md-3">
        <img src={env.images.icon.parcela} className="parcela-icon" />
        {/* <img src={env.images.icon.parcela} style={{ width: window.innerWidth < 1200 ? '50px' : '80px' }} /> */}
      </div>
      <div className="col-xs-7 col-md-7">
        <h6 className="font-lato-normal-400">
          {cuenta_uuid ? (
            <a style={{ color: 'black' }} href={'/admin/cuentas/perfil/' + cuenta_uuid}>
              Propietario: {cuenta_name}
            </a>
          ) : (
            <>Propietario: {cuenta_name}</>
          )}
        </h6>

        <h4 className="font-lato-normal-500">{parcela_name || '-'}</h4>

        <h6 className="font-lato-normal-400">
          {localidad}, {municipio}
        </h6>
      </div>
      <div className="col-xs-2 col-md-2">
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: '6px' }}>
          {certifications?.map(cert => (
            <img
              key={cert.id}
              src={`${env.assetURL}${cert.url}`}
              alt={cert.name}
              style={{
                height: '40px',
                minHeight: '32px',
                width: 'auto',
                maxWidth: '100%',
              }}></img>
          ))}
        </div>
      </div>
    </>
  );
};

export default CardTitleParcela;
